import React from "react";
import {FormControl, InputLabel, MenuItem} from "@mui/material";
import { SelectValidator } from "react-material-ui-form-validator"
import Grid from "@mui/material/Grid";

const SelectInput = ({items, displayEmpty, sm, xs, ...props}) => (
    <Grid item xs={xs ?? 12} sm={sm ?? 6}>
        <React.Fragment>
            <SelectValidator
                {...props}
            >
                <MenuItem value="" disabled>
                    <em>Aucun</em>
                </MenuItem>
                {
                    items.length > 0 && items.map((item, key) => <MenuItem key={key} value={item.value}>{item.label}</MenuItem>)
                }
            </SelectValidator>
        </React.Fragment>
    </Grid>

)

export default SelectInput;
